export default __webpack_public_path__ + "static/media/project-evently.fb7ef06f.jpg";